import moment from 'moment';
import { Nullable } from '../../../../internal/src/@types/common';
import { FlagMarker, Group, GroupRegistrationCode, MemberStatus, Phone, WithPreferredFlag } from '../../@types/Members';

export function memberIsActive(effectiveStartDate: string, effectiveEndDate?: string): boolean {
  const memberStatus = getMemberStatus(effectiveStartDate, effectiveEndDate);
  return memberStatus === MemberStatus.MEMBERSTATUS_ACT;
}

export function getMemberStatus(effectiveStartDate: string, effectiveEndDate?: string): Nullable<MemberStatus> {
  const now = moment();
  const start = moment(effectiveStartDate);
  const end = effectiveEndDate ? moment(effectiveEndDate) : null;

  switch (true) {
    case end?.isBefore(start):
      return MemberStatus.MEMBERSTATUS_INA;
    case start.isAfter(now):
      return MemberStatus.MEMBERSTATUS_PEN;
    case end === null || end?.isAfter(now):
      return MemberStatus.MEMBERSTATUS_ACT;
    default:
      return MemberStatus.MEMBERSTATUS_INA;
  }
}

export function getMemberStatusLabel(status: Nullable<MemberStatus>): string {
  if (!status) {
    return 'Unknown';
  }

  const label: Record<MemberStatus, string> = {
    MEMBERSTATUS_ACT: 'Active',
    MEMBERSTATUS_INA: 'Inactive',
    MEMBERSTATUS_PEN: 'Pending'
  };

  return label[status];
}

export function getMemberStatusTextClass(status: Nullable<MemberStatus>): Nullable<string> {
  if (!status) {
    return null;
  }

  const states = {
    MEMBERSTATUS_ACT: 'text-primary-green',
    MEMBERSTATUS_INA: 'text-primary-red',
    MEMBERSTATUS_PEN: 'text-primary-blue'
  };

  return states[status];
}

export function processPreferredFlag<T extends WithPreferredFlag<unknown>>(
  o: T
): WithPreferredFlag<Omit<T, 'isPreferred'>> {
  const { isPreferred, ...rest } = o;
  return { ...rest, preferredFlg: isPreferred ? FlagMarker.Y : FlagMarker.N };
}

export function separateAreaCode(object: Phone): Phone {
  return { ...object!, phoneNumber: object!.phoneNumber.slice(3), areaCode: object!.phoneNumber.slice(0, 3) };
}

export const isClientSiteRegistration = (regType: string): boolean =>
  regType === GroupRegistrationCode.REGTYPE_STAGEDCLIENT;

export const isClientSiteGroup = ({ primarySourceRegistration, dependentSourceRegistration }: Group): boolean =>
  isClientSiteRegistration(primarySourceRegistration);

export const memberIsAssignedToClientSiteGroup = ({ group }: any): boolean => isClientSiteGroup(group);

export const ensureDatePropertyValueIsValid = (entry: any, property: string) => {
  const propertyValue = entry[property];
  if (!propertyValue) {
    return;
  }

  const dateValue = moment.utc(propertyValue);
  if (dateValue.isValid() && dateValue.year() !== 9999) {
    return;
  }

  entry[property] = null;
};

export const defaultItemsPerPage = { label: '10', value: 10 };
export const defaultPageNumber: number = 1;
